if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"mutationsApp","remotes":[],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^([12]03|155|642|739|762|904)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}